import * as z from "zod";

export const removeFileExchangeSftpPublicKey = {
  name: "removeFileExchangeSftpPublicKey" as const,
  input: z.object({ fingerprint: z.string().startsWith("SHA256:") }),
  output: z.object({}),
};
